import { IMedication } from '@/Models/IMedication';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class medicationService extends BaseApiService {
    public constructor() {
		super('Medication/');
    }

	public async getById(id: number): Promise<IMedication> {
		return this.httpClient.get<IMedication>(`GetById/${id}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async getByCaseId(caseId: number): Promise<IMedication[]> {
		return this.httpClient.get<IMedication[]>(`GetByCaseId/${caseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async save(dto: IMedication): Promise<ITypedValidationResult<IMedication>> {
		return this.httpClient.post<ITypedValidationResult<IMedication>>("Save", dto).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}

	public async delete(id: number): Promise<ITypedValidationResult<IMedication>> {
		return this.httpClient.delete<ITypedValidationResult<IMedication>>(`Delete/${id}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}
}

export const MedicationService: medicationService = new medicationService();